import { Fragment, useState, useCallback, useEffect, FormEvent, SetStateAction } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom'
import { IVDetails, RegisterHeader } from '../../Components/Index'
import './ExamSlip.scss'
import { BASE_URL_ADDR } from "../../../../Constants/BaseURL";
import Footer from '../../../../Layout/Footer';

const ExamSlip = () => {
  const { nin }:any = useParams();
  const [refInput, setRefInput] = useState<string>(nin || "");
  const [loading, setLoading] = useState<boolean>(false);
  const [applicationResults, setApplicationResults] = useState<any>();
  const [error, setError] = useState<any>();

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    preview();
  }

  const changeRef = useCallback((e: { target: { value: SetStateAction<string>; }; }) => {
    setRefInput(e.target.value);
  }, [setRefInput]);

  useEffect(() => {
    if (nin) {
      preview();
    }
    return () => {}
  }, [nin])

  const preview = async () => {
    setLoading(true);
    setError(undefined);

    axios({
      method: 'GET',
      url: `${BASE_URL_ADDR}/query-aptitude-status?nin=${refInput}`,
      headers: {
        'content-type': 'application/json',
        Accept: 'application/json',
      },
    }).then(async response => {
      setApplicationResults({ ...response.data.dataset.formData, ...response.data.dataset.workflow, authQR: response.data.authQR, photo: response.data.photo });
    }).catch(error => {
      setError(error?.response?.data?.message || "Application does not exist!");
      console.log(error);
    }).finally(() => {
      setLoading(false);
    })
  }

  return (
    <Fragment>
      <RegisterHeader />
      <main role="main" className="exam-slip-page">

        {/* Search form state */}
        {!applicationResults && (
          <div className="print-slip-request">
            <div className="print-slip-request__hero">
              <div className="container">
                <div className="print-slip-request__hero-content">
                  <h1 className="print-slip-request__title text-white">Aptitude Invitation Slip</h1>
                  <p className="print-slip-request__subtitle">
                    All candidates should follow the instructions provided in this section
                  </p>
                </div>
              </div>
            </div>

            <div className="print-slip-request__content mt-5 pt-5">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-12 col-lg-8 col-xl-7">
                    <div className="print-slip-request__card">
                      <div className="print-slip-request__card-header">
                        <h2 className="print-slip-request__card-title">Preview Your Form</h2>
                        <p className="print-slip-request__card-description">
                          Enter your National Identification No to preview and print your aptitude invitation for writing exam.
                        </p>
                      </div>

                      <form onSubmit={onSubmit} className="print-slip-request__form">
                        {!nin && (
                          <div className="print-slip-request__form-group">
                            <label htmlFor="refid" className="print-slip-request__label">
                              <span className="print-slip-request__label-text">National Identification Number (NIN)</span>
                              <span className="print-slip-request__label-required">*</span>
                            </label>
                            <div className="print-slip-request__input-wrapper">
                              <svg className="print-slip-request__input-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                <circle cx="12" cy="7" r="4"></circle>
                              </svg>
                              <input
                                id="refid"
                                type="text"
                                className={`print-slip-request__input ${error ? 'print-slip-request__input--error' : ''}`}
                                onChange={changeRef}
                                value={refInput}
                                placeholder="Enter your 11-digit NIN"
                                disabled={loading}
                              />
                            </div>
                            {error && (
                              <div className="print-slip-request__error" role="alert">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                  <circle cx="12" cy="12" r="10"></circle>
                                  <line x1="12" y1="8" x2="12" y2="12"></line>
                                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                                </svg>
                                <span>{error}</span>
                              </div>
                            )}
                          </div>
                        )}

                        <div className="print-slip-request__form-actions">
                          <button type="submit" className="print-slip-request__submit-btn" disabled={loading}>
                            {loading
                              ? (
                              <>
                                <div className="spinner-border spinner-border-sm" role="status">
                                  <span className="sr-only">Loading...</span>
                                </div>
                                <span>Loading...</span>
                              </>
                                )
                              : (
                              <>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                  <polyline points="14 2 14 8 20 8"></polyline>
                                </svg>
                                <span>Preview Form</span>
                              </>
                                )}
                          </button>
                        </div>
                      </form>

                      <div className="print-slip-request__help">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="12" cy="12" r="10"></circle>
                          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                          <line x1="12" y1="17" x2="12.01" y2="17"></line>
                        </svg>
                        <span>Make sure to bring your printed aptitude invitation to the examination venue.</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Results state */}
        {applicationResults && (
          <section className="slip-tabs-section my-5 pt-5">
            <div className="container">
              <IVDetails value={applicationResults} disable={true} />

              {/* Print button */}
              <div className="card mb-4 no-print">
                <div className="card-body text-center">
                  <button onClick={() => window.print()} className="btn btn-dark">
                    Print Aptitude Invitation
                  </button>
                </div>
              </div>

            </div>
          </section>
        )}

      </main>
      <Footer />
    </Fragment>
  )
}

export default ExamSlip
